import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    Grid,
    FormControl,
    Select,
    MenuItem,
    TextField,
    CircularProgress,
    InputLabel,
    Tabs,
    Tab,
    Autocomplete,
    Typography,
    Divider,
    Box
} from '@mui/material';

import { Formik, Form } from 'formik';
import axios from 'axios';

const headers = {
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
        'Content-Type': 'application/json'
    }
};

export const AddPrevSerialization = ({
    open,
    handleClose,
    handleSubmit,
    handleSubmitGradeSheet,
    serializationData,
    gradeSerializationData,
    examEditData
}) => {
    const initialvalGradeSheet = {
        gradeSheets:
            examEditData?.courseDetailInfo?.map((course) => {
                const existingGradeSheet = gradeSerializationData?.find((item) => item.courseId === course.courseId);

                return {
                    courseId: course.courseId,
                    defaultGradeSerial: existingGradeSheet?.defaultGradeSerial ?? true,
                    examGroupId: examEditData?.id,
                    id: existingGradeSheet?.id || '',
                    sessionId: existingGradeSheet?.sessionId || examEditData?.sessionIds[0],
                    startsFrom: existingGradeSheet?.startsFrom || 0
                };
            }) || []
    };

    console.log(gradeSerializationData, 'examEditData');

    const [tabIndex, setTabIndex] = useState(0);
    const [courseList, setCourseList] = useState([]);
    const fetchCourses = () => {
        axios.get(`/v1/course-details/list/by-multiple-session?sessionIds=${examEditData?.sessionIds[0]}`, headers).then((response) => {
            const courses = response.data?.courseDetailList;
            setCourseList(courses);
        });
    };
    useEffect(() => {
        if (examEditData?.sessionIds[0]) fetchCourses();
    }, [examEditData?.sessionIds[0]]);
    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Add Serialization</DialogTitle>
            <DialogContent>
                <Tabs value={tabIndex} onChange={handleTabChange} aria-label="serialization tabs">
                    {/* <Tab label="Hall Ticket Serialization" /> */}
                    <Tab label="Grade Sheet Serialization" />
                </Tabs>

                {/* {tabIndex === 0 && (
                    <Formik
                        initialValues={{
                            courseType: serializationData?.courseType || '',
                            numberLength: serializationData?.numberLength || '',
                            enrollmentStartsFrom: serializationData?.enrollmentStartsFrom || '',
                            year: serializationData?.year || ''
                        }}
                        onSubmit={handleSubmit}
                        enableReinitialize
                    >
                        {({ values, handleChange, isSubmitting }) => (
                            <Form>
                                <Grid container spacing={2} mt={1}>
                                    <Grid item xs={12} md={6}>
                                        <FormControl fullWidth>
                                            <InputLabel id="course-type-label">Select Course Type</InputLabel>
                                            <Select
                                                labelId="course-type-label"
                                                id="courseType"
                                                label="Select Course Type"
                                                name="courseType"
                                                value={values.courseType}
                                                onChange={handleChange}
                                            >
                                                <MenuItem value="ALL">ALL</MenuItem>
                                                <MenuItem value="UG">UG</MenuItem>
                                                <MenuItem value="PG">PG</MenuItem>
                                                <MenuItem value="PHD">PHD</MenuItem>
                                                <MenuItem value="Diploma">Diploma</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            fullWidth
                                            id="numberLength"
                                            name="numberLength"
                                            inputProps={{ type: 'number' }}
                                            label="Number Length"
                                            value={values.numberLength}
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            fullWidth
                                            id="enrollmentStartsFrom"
                                            name="enrollmentStartsFrom"
                                            type="number"
                                            label="Enrollment Starts From"
                                            value={values.enrollmentStartsFrom}
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            fullWidth
                                            id="year"
                                            name="year"
                                            label="Year"
                                            value={values.year}
                                            onChange={handleChange}
                                        />
                                    </Grid>

                                    <Grid item xs={12} display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
                                        <Button variant="outlined" onClick={handleClose} color="secondary">
                                            Close
                                        </Button>
                                        <Button
                                            variant="contained"
                                            type="submit"
                                            startIcon={isSubmitting ? <CircularProgress size="1rem" /> : undefined}
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? 'Please Wait' : 'Submit'}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Form>
                        )}
                    </Formik>
                )} */}

                {tabIndex === 0 && (
                    <Formik initialValues={initialvalGradeSheet} onSubmit={handleSubmitGradeSheet} enableReinitialize>
                        {({ values, handleChange, isSubmitting }) => (
                            <Form>
                                <Grid container spacing={2} mt={2}>
                                    {values.gradeSheets?.map((gradeSheet, index) => {
                                        const course = courseList.find((c) => c.courseId === gradeSheet.courseId);
                                        const courseName = course?.course?.courseName || 'Unknown Course';

                                        return (
                                            <React.Fragment key={index}>
                                                <Grid item xs={12} md={6} sx={{ mb: 1 }}>
                                                    <TextField
                                                        fullWidth
                                                        id={`gradeSheets[${index}].courseId`}
                                                        name={`gradeSheets[${index}].courseId`}
                                                        label="Program"
                                                        value={courseName}
                                                        disabled
                                                        InputProps={{
                                                            inputComponent: ({ ...props }) => (
                                                                <>
                                                                    <input
                                                                        type="hidden"
                                                                        name={`gradeSheets[${index}].courseId`}
                                                                        value={gradeSheet.courseId}
                                                                    />
                                                                    <Typography variant="body1" sx={{ p: 2 }}>
                                                                        {courseName}
                                                                    </Typography>
                                                                </>
                                                            )
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        fullWidth
                                                        id={`gradeSheets[${index}].startsFrom`}
                                                        name={`gradeSheets[${index}].startsFrom`}
                                                        type="number"
                                                        label="Starts From"
                                                        value={gradeSheet.startsFrom}
                                                        onChange={handleChange}
                                                        InputProps={{
                                                            inputProps: {
                                                                min: 0,
                                                                step: 1
                                                            }
                                                        }}
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                borderRadius: '8px'
                                                            }
                                                        }}
                                                    />
                                                </Grid>

                                                {/* Divider between course groups except last one */}
                                                {index < values.gradeSheets.length - 1 && (
                                                    <Grid item xs={12}>
                                                        <Divider sx={{ my: 1 }} />
                                                    </Grid>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}

                                    <Grid item xs={12} sx={{ mt: 2 }}>
                                        <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
                                            <Button
                                                variant="outlined"
                                                onClick={handleClose}
                                                color="secondary"
                                                sx={{
                                                    px: 3,
                                                    borderRadius: '8px',
                                                    textTransform: 'none'
                                                }}
                                            >
                                                Close
                                            </Button>
                                            <Button
                                                variant="contained"
                                                type="submit"
                                                startIcon={isSubmitting ? <CircularProgress size="1rem" /> : undefined}
                                                disabled={isSubmitting}
                                                sx={{
                                                    textTransform: 'none',
                                                    boxShadow: 'none',
                                                    '&:hover': {
                                                        boxShadow: 'none'
                                                    }
                                                }}
                                            >
                                                {isSubmitting ? 'Processing...' : 'Save'}
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Form>
                        )}
                    </Formik>
                )}
            </DialogContent>
        </Dialog>
        // <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        //     <DialogTitle>Add Hall Ticket Serialization</DialogTitle>
        //     <DialogContent>
        //         <Formik
        //             initialValues={{
        //                 courseType: serializationData?.courseType || '',
        //                 numberLength: serializationData?.numberLength || '',
        //                 enrollmentStartsFrom: serializationData?.enrollmentStartsFrom || '',
        //                 year: serializationData?.year || ''
        //             }}
        //             onSubmit={handleSubmit}
        //             enableReinitialize
        //         >
        //             {({ values, handleChange, isSubmitting }) => (
        //                 <Form>
        //                     <Grid container spacing={2}>
        //                         <Grid item xs={12} mt={1}>
        //                             <FormControl fullWidth>
        //                                 <InputLabel id="course-type-label">Select Course Type</InputLabel>
        //                                 <Select
        //                                     labelId="course-type-label"
        //                                     id="courseType"
        //                                     label="Select Course Type"
        //                                     name="courseType"
        //                                     value={values.courseType}
        //                                     onChange={(event) => {
        //                                         handleChange(event);
        //                                     }}
        //                                 >
        //                                     <MenuItem value="ALL">ALL</MenuItem>
        //                                     <MenuItem value="UG">UG</MenuItem>
        //                                     <MenuItem value="PG">PG</MenuItem>
        //                                     <MenuItem value="PHD">PHD</MenuItem>
        //                                     <MenuItem value="Diploma">Diploma</MenuItem>
        //                                 </Select>
        //                             </FormControl>
        //                         </Grid>

        //                         <Grid item xs={12}>
        //                             <TextField
        //                                 fullWidth
        //                                 id="numberLength"
        //                                 name="numberLength"
        //                                 inputProps={{ type: 'number' }}
        //                                 label="Number Length"
        //                                 value={values.numberLength}
        //                                 onChange={handleChange}
        //                             />
        //                         </Grid>
        //                         <Grid item xs={12}>
        //                             <TextField
        //                                 fullWidth
        //                                 id="enrollmentStartsFrom"
        //                                 name="enrollmentStartsFrom"
        //                                 type="number"
        //                                 label="Enrollment Starts From"
        //                                 value={values.enrollmentStartsFrom}
        //                                 onChange={handleChange}
        //                             />
        //                         </Grid>
        //                         <Grid item xs={12}>
        //                             <TextField fullWidth id="year" name="year" label="Year" value={values.year} onChange={handleChange} />
        //                         </Grid>

        //                         <Grid item xs={12} display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
        //                             <Button
        //
        //                                 variant="contained"
        //                                 type="submit"
        //                                 startIcon={isSubmitting ? <CircularProgress size="1rem" /> : undefined}
        //                                 disabled={isSubmitting}
        //                             >
        //                                 {isSubmitting ? 'Please Wait' : 'Submit'}
        //                             </Button>
        //                             <Button onClick={handleClose} color="secondary" >
        //                                 Close
        //                             </Button>
        //                         </Grid>
        //                     </Grid>
        //                 </Form>
        //             )}
        //         </Formik>
        //     </DialogContent>
        // </Dialog>
    );
};

export default AddPrevSerialization;
